import React from "react"

const Home = (props) => {


    return (
        <div className='home'>
            <h1>Welcome</h1>
            <p>Please signup and then login to view your Events</p>
        </div>
    ) 
}

export default Home